<template>
  <el-dialog :visible="innerVisible" :title="$t('Sop.sift')" width="1250px" :show-close="false">
    <approval-search
      :status="0"
      :filter="filter"
      :type="type"
      :document-config-id="documentConfigId"
      :per-config-name.sync="perConfigName"
      :grid-refresh-id.sync="gridRefreshId"
      :expand-adv="true"
      @toQuery="handleFilter"
    />
    <template slot="footer">
      <!--      <el-button type="primary" @click="clear">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>-->
      <!--      <el-button type="primary" @click="handleFilter">{{ $t('common.btn.query') }}</el-button>-->
      <el-button @click="restForm">{{ $t('SeaExport.Cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import ApprovalSearch from '@/components/Cargo/Common/Wrokflow/approvalSearch'

export default {
  name: 'MoreApprovalFilterDialog',
  components: { ApprovalSearch },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    filter: {
      type: Object,
      default: () => {}
    },
    // look：我发起的、approve：我处理的
    type: { type: String, default: '' },
    // 是否选择表单类型
    documentConfigId: { type: Number, default: 0 },
    perConfigNameProp: { type: String, default: '' },
    gridRefreshIdProp: { type: Number, default: 0 }
  },
  data() {
    return {
      configContent: '',
      perConfigName: this.perConfigNameProp,
      gridRefreshId: this.gridRefreshIdProp
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    perConfigName: {
      immediate: true,
      async handler() {
        this.$emit('update:perConfigNameProp', this.perConfigName)
      }
    },
    gridRefreshId: {
      immediate: true,
      async handler() {
        // this.gridRefreshIdProp = this.gridRefreshId
        this.$emit('update:gridRefreshIdProp', this.gridRefreshId)
      }
    }
  },
  methods: {
    clear() {
      const params = this.filter
      params.total = 0
      params.pageNum = 0
      params.pageSize = 10
      params.startDate = ''
      params.officeIdList = []
      params.workflowName = ''
      params.approvalDate = ''
      params.approveIdList = []
      params.state = 0
      params.approvalTemplate = ''
      params.documentConfigIdList = []
      params.documentProcessNo = ''
    },
    handleFilter() {
      this.innerVisible = false
      this.$emit('toQuery')
    },
    restForm() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.el-dropdown{
  width: 100%;
}
.el-dropdown-menu{
  width: 323.325px;
}
</style>
